/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#business-fuel-disclaimer[_ngcontent-%COMP%]{font-size:14px}"];
export { styles as styles };
